import { Any, JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";
import { CashbackArrayCounter, Counters } from "../cashback/counters";

@JsonConverter
export class InvitationArrayConverter implements JsonCustomConvert<Array<Invitation>>{
    serialize() { }
    deserialize(data: any): Array<Invitation> {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeArray(data, Invitation);
    }
}
@JsonConverter
export class InvitationConverter implements JsonCustomConvert<Invitation>{
    serialize() { }
    deserialize(data: any): Invitation {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeObject(data, Invitation);
    }
}


@JsonObject("Invitation")
export class Invitation {
    @JsonProperty("id", String, true)
    id: string = "";
    @JsonProperty("email", String, true)
    email: string = "";
    @JsonProperty("first_name", String, true)
    first_name: string = "";
    @JsonProperty("last_name", String, true)
    last_name: string = "";
    @JsonProperty("phone_number", String, true)
    phone_number: string = "";
    // @JsonProperty("location", String, true)
    // location: string = "";
    // @JsonProperty("policy", String, true)
    // policy: string = "";
    // @JsonProperty("type", String, true)
    // type: string = "";
    @JsonProperty("valid_from", Number, true)
    valid_from: number = 0;
    @JsonProperty("valid_to", Number, true)
    valid_to: number = 0;
    // @JsonProperty("max_devices", Number, true)
    // max_devices: number = 0;
    @JsonProperty("notes", String, true)
    notes: string = "";
    // @JsonProperty("user_type", String, true)
    // user_type: string = "";
    // @JsonProperty("status", String, true)
    // status: string = "";
    // @JsonProperty("sent_at", Number, true)
    // sent_at: number = 0;
    @JsonProperty("expiration_hours", Number, true)
    expiration_hours: number = 0;


    toDto() {
        return {
            email: this.email,
            first_name: this.first_name,
            last_name: this.last_name,
            phone_number: this.phone_number,
            // location: this.location,
            // policy: this.policy,
            // type: this.type,
            valid_from: this.valid_from,
            valid_to: this.valid_to,
            // max_devices: this.max_devices,
            notes: this.notes,
            // user_type: this.user_type,
            // status: this.status,
            // sent_at: this.sent_at,
            expiration_hours: this.expiration_hours

        };
    }
}


@JsonObject("InvitationData")
export class InvitationData extends BaseResponse{
    @JsonProperty("data", InvitationConverter, true)
    data: Invitation = new Invitation();
}
